import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'principals',
  templateUrl: './principals.component.html',
  styleUrls: ['./principals.component.css']
})
export class PrincipalsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
